/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'social/share': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M19.434 6.217a3.52 3.52 0 11-2.489 6.01l-3.909 2.512a3.51 3.51 0 010 2.46l3.91 2.513a3.52 3.52 0 11-.811 1.262l-3.91-2.514a3.52 3.52 0 110-4.982l3.909-2.513a3.521 3.521 0 013.3-4.748zm0 13.966a2.021 2.021 0 000 4.04 2.02 2.02 0 000-4.04zm-9.696-6.234a2.021 2.021 0 10.001 4.042 2.021 2.021 0 000-4.042zm9.696-6.232a2.021 2.021 0 100 4.042 2.021 2.021 0 000-4.042z" _fill="#0077C8"/>'
  }
})
